import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectId } from 'api/models';
import { Task, TaskCreationRequest, TasksStore } from './store';

export const tasksSlice = createSlice({
  name: '@@TASKS',
  initialState: TasksStore.empty(),
  reducers: {
    add: (state: TasksStore, { payload: task }: PayloadAction<Task>) =>
      TasksStore.add(task)(state),
    creating: (
      state: TasksStore,
      { payload: [task, id] }: PayloadAction<[TaskCreationRequest, string]>,
    ) => TasksStore.creating(task, id)(state),
    created: (
      state: TasksStore,
      { payload: [task, id] }: PayloadAction<[Task, string]>,
    ) => TasksStore.created(task, id)(state),
    failed: (state: TasksStore, { payload: id }: PayloadAction<string>) =>
      TasksStore.failed(id)(state),
    loadingProjectTasks: (
      state: TasksStore,
      { payload: projectId }: PayloadAction<ProjectId>,
    ) => TasksStore.loadingProjectTasks(projectId)(state),
    loadedProjectTasks: (
      state: TasksStore,
      { payload: [projectId, tasks] }: PayloadAction<[ProjectId, Task[]]>,
    ) => TasksStore.loadedProjectTasks(projectId, tasks)(state),
    loadingAllTasks: (
      state: TasksStore,
      { payload: projectIds }: PayloadAction<ProjectId[]>,
    ) => TasksStore.loadingAllTasks(projectIds)(state),
    loadedAllTasks: (
      state: TasksStore,
      { payload: tasks }: PayloadAction<Task[]>,
    ) => TasksStore.loadedAllTasks(tasks)(state),
    updating: (state: TasksStore, { payload: tasks }: PayloadAction<Task[]>) =>
      TasksStore.updating(tasks)(state),
    updated: (state: TasksStore, { payload: tasks }: PayloadAction<Task[]>) =>
      TasksStore.updated(tasks)(state),
    revert: (
      state: TasksStore,
      { payload: taskIds }: PayloadAction<number[]>,
    ) => TasksStore.revert(taskIds)(state),
    deleting: (state: TasksStore, { payload: tasks }: PayloadAction<Task[]>) =>
      TasksStore.deleting(tasks)(state),
    deleted: (
      state: TasksStore,
      { payload: tasks }: PayloadAction<Pick<Task, 'taskId'>[]>,
    ) => TasksStore.deleted(tasks.map((x) => x.taskId))(state),
    restored: (
      state: TasksStore,
      { payload: tasks }: PayloadAction<Pick<Task, 'taskId'>[]>,
    ) => TasksStore.restored(tasks.map((x) => x.taskId))(state),
  },
});
